<div class="modal-header">
  <h4 class="modal-title" translate>UPLOAD</h4>
  <button
    type="button"
    class="close"
    aria-label="Close"
    [disabled]="spinner ? true : null"
    (click)="activeModal.dismiss('Cross click')"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col">
      <div class="input-group mb-3">
        <div class="custom-file">
          <input
            #inputFile
            type="file"
            class="_custom-file-input"
            id="inputGroupFile01"
            aria-describedby="inputGroupFileAddon01"
            (change)="onFileSelect($event)"
            [disabled]="spinner ? true : null"
            [multiple]="multiple ? true : false"
          />
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <lib-gung-text-input
        #inputDescription
        gungTranslate="{{ 'DESCRIPTION' }}"
        placeholder="{{ 'DESCRIPTION' | translate }}"
      ></lib-gung-text-input>
    </div>
  </div>
  <div class="row pt-3">
    <label for="inMenu" class="col-form-label col-12 col-sm-4 font-weight-bold" translate>VISIBLE_IN_MENU</label>
    <div class="col d-flex align-items-center">
      <input type="checkbox" #inMenu id="inMenu" name="inMenu" [disabled]="spinner ? true : null" />
    </div>
    <label for="showInDocumentView" class="col-form-label col-12 col-sm-4 font-weight-bold" translate
      >VISIBLE_ON_DOCUMENT_PAGE</label
    >
    <div class="col d-flex align-items-center">
      <input
        type="checkbox"
        #showInDocumentView
        id="showInDocumentView"
        name="showInDocumentView"
        [disabled]="spinner ? true : null"
      />
    </div>
  </div>

  <lib-gung-input-multi-select
    *ngIf="enableDocumentUserGroups && settingsGroups && settingsGroups.length >= 0"
    label="VISIBLE_FOR_ROLES"
    [optionsList]="getUserGroups()"
    (selectedValues)="setSelectedValues($event)"
  >
  </lib-gung-input-multi-select>

  <div class="row" style="padding: 0px 10px" *ngIf="enableDocumentUserGroups">
    <a style="font-size: 60%" *ngIf="!advanced" (click)="advanced = !advanced" translate>SHOW_ADVANCED</a>
    <a style="font-size: 60%" *ngIf="advanced" (click)="advanced = !advanced" translate>HIDE_ADVANCED</a>
    <div class="w-100 pt-3" *ngIf="advanced">
      <lib-gung-text-input
        gungTranslate="VISIBLE_FOR_ASSORTMENTS"
        [(ngModel)]="includedAssortments"
      ></lib-gung-text-input>
      <lib-gung-text-input gungTranslate="VISIBLE_FOR_CUSTOMERS" [(ngModel)]="includedCustomers"></lib-gung-text-input>
      <lib-gung-text-input gungTranslate="HIDE_FOR_CUSTOMERS" [(ngModel)]="excludedCustomers"></lib-gung-text-input>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-outline-dark"
    (click)="activeModal.close('Close click')"
    [disabled]="spinner ? true : null"
    translate
  >
    CLOSE
  </button>
  <button
    type="button"
    class="btn btn-primary"
    (click)="onUploadTylo(inputFile, inputDescription, inMenu, showInDocumentView)"
    [disabled]="spinner ? true : null"
    translate
  >
    UPLOAD <i *ngIf="spinner" class="fa fa-spinner fa-spin fa-lg"></i>
  </button>
</div>
